<div class="window">
    <div class="window-summary" id="summary" *ngIf="pageFooterSummary">
        <ng-container [ngTemplateOutlet]="pageFooterSummary"></ng-container>
    </div>
    <div class="window-main">
        <div class="window-main-controls" id="controls" *ngIf="pageFooterControls">
            <ng-container [ngTemplateOutlet]="pageFooterControls"></ng-container>
        </div>
        <div class="window-main-buttons" id="buttons">
            <ng-container [ngTemplateOutlet]="pageFooterButtons"></ng-container>
        </div>
    </div>
</div>
